
import { Box, Typography, Container, Grid, Button, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import { WhatsApp, Email, CalendarToday, Forum } from '@mui/icons-material';

const DirectAccess = () => {
  const accessPoints = [
    { icon: <WhatsApp />, title: 'WhatsApp Direct', description: 'Instant messaging access', action: 'Chat Now', link: 'https://wa.me/27720100332' },
    { icon: <Email />, title: 'Email Priority', description: '3-business day response guarantee', action: 'Send Email', link: 'mailto:John.Asfar@JohnAsfar.com' },
    { icon: <CalendarToday />, title: 'Schedule Meeting', description: 'Book executive time', action: 'Book Now', link: '/contact' },
    { icon: <Forum />, title: 'Direct Q&A', description: 'Pitch ideas, ask questions', action: 'Start Conversation', link: '/contact' },
  ];

  return (
    <Box sx={{ py: 15, background: '#111' }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="subtitle1"
            sx={{ color: '#C8A96B', letterSpacing: 4, mb: 2, textAlign: 'center' }}
          >
            DIRECT COMMUNICATION
          </Typography>

          <Typography
            variant="h2"
            sx={{
              textAlign: 'center',
              mb: 4,
              fontSize: { xs: '2rem', md: '3.5rem' },
            }}
          >
            Access Without Barriers
          </Typography>

          <Typography
            sx={{
              textAlign: 'center',
              maxWidth: '700px',
              mx: 'auto',
              color: '#ccc',
              mb: 8,
            }}
          >
            Connect directly with John Asfar through your preferred channel.
            No secretaries, no protocols, no delays.
          </Typography>
        </motion.div>

        <Grid container spacing={4}>
          {accessPoints.map((point, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Box
                  sx={{
                    p: 4,
                    textAlign: 'center',
                    background: 'linear-gradient(135deg, #1A1A1A, #111)',
                    borderRadius: 4,
                    border: '1px solid rgba(200,169,107,0.2)',
                    height: '100%',
                    transition: 'all 0.3s',
                    '&:hover': {
                      borderColor: '#C8A96B',
                      transform: 'scale(1.02)',
                    },
                  }}
                >
                  <Box sx={{ color: '#C8A96B', fontSize: 56, mb: 2 }}>
                    {point.icon}
                  </Box>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                    {point.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#999', mb: 3 }}>
                    {point.description}
                  </Typography>
                  <Button
                    href={point.link}
                    target={point.link.startsWith('http') ? '_blank' : '_self'}
                    variant="outlined"
                    size="small"
                    sx={{
                      borderColor: '#C8A96B',
                      color: '#C8A96B',
                      '&:hover': {
                        background: '#C8A96B',
                        color: '#000',
                      },
                    }}
                  >
                    {point.action}
                  </Button>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default DirectAccess;